import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { PerfVsIndexCapsuleConfigState } from 'widgets/perfVsIndexCapsule/store/config/PerfVsIndexCapsuleConfigState';
import { useFillsGraphStreamedData } from 'widgets/fillsGraph/store/streamedData/hooks';

import './PerfVsIndexCapsuleMyPortfolioCapsuleTitle.scss';
import { useFillsGraphDataIndexDescription } from 'widgets/fillsGraph/store/data/hooks';

export function PerfVsIndexCapsuleMyPortfolioCapsuleTitle(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config } =
        useMyPortfolioCapsuleConfigSlice<PerfVsIndexCapsuleConfigState>();

    const { indexFallback } = config;

    const { streamedData, streamKey } = useFillsGraphStreamedData(
        symbol,
        indexFallback
    );

    const indexDescription = useFillsGraphDataIndexDescription(
        streamedData?.data
    );

    const index = symbol && indexDescription ? indexDescription : '';

    return (
        <span
            className="PerfVsIndexCapsuleMyPortfolioCapsuleTitle"
            data-stream-key={streamKey}
        >
            {symbol}
            <span className="subtitle">
                {' '}
                vs {index.length > 0 ? index : 'Index'}
            </span>
        </span>
    );
}
